module.exports = __webpack_public_path__ + "static/media/shape3.aeacc99a.webp";